import React, { useState } from 'react';
import { FaEye, FaEyeSlash,  FaUser, FaLock, FaEnvelope, FaPhone, FaGamepad } from 'react-icons/fa';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import './Signup.css';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_num: '',
    password: '',
    confirmPassword: '',
    ff_name: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showNote, setShowNote] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async () => {
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post('https://backend.aubattle.com/api/auth/signup', {
        name: formData.name,
        email: formData.email,
        phone_num: formData.phone_num,
        password: formData.password,
        ff_name: formData.ff_name
      });

      setSuccess(res.data.message);
      setError(null);
      localStorage.setItem('authToken', res.data.token);
      setTimeout(() => navigate('/dashboard'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignup = async (credentialResponse) => {
    try {
      const res = await axios.post('https://backend.aubattle.com/api/auth/google-auth', { 
        tokenId: credentialResponse.credential 
      });

      if (res.data.token) {
        localStorage.setItem('authToken', res.data.token);
        setSuccess(res.data.message);
        setTimeout(() => navigate('/dashboard'), 2000);
      }
    } catch (err) {
      setError(err.response?.data?.error || "Google Authentication Failed!");
    }
  };

  return (
    <GoogleOAuthProvider clientId="435743230987-lj3212qf43ua8lg2a96qhckobm32q46k.apps.googleusercontent.com">
      <div className="auth-container">
        <div className="auth-glass-card">
        

          <div className="auth-header">
            <h1>Create Account</h1>
            <p>Join our gaming community today</p>
          </div>

          <div className="auth-form">
            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                onFocus={() => setShowNote(true)}
                onBlur={() => setShowNote(false)}
              />
              {showNote && (
                <div className="input-note">
                  Must match your Free Fire ID exactly for withdrawals
                </div>
              )}
            </div>

            <div className="input-group">
              <FaPhone className="input-icon" />
              <input
                type="text"
                name="phone_num"
                placeholder="Phone Number"
                value={formData.phone_num}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
              <button 
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <FaGamepad className="input-icon" />
              <input
                type="text"
                name="ff_name"
                placeholder="Free Fire ID"
                required
                value={formData.ff_name}
                onChange={handleChange}
              />
            </div>

            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}

            <button 
              className="auth-primary-btn" 
              onClick={handleSignup}
              disabled={loading}
            >
              {loading ? <div className="auth-spinner"></div> : 'Create Account'}
            </button>

            <div className="auth-divider">
              <span>OR</span>
            </div>

            <div className="auth-social">
              <GoogleLogin 
                onSuccess={handleGoogleSignup}
                onError={() => setError('Google signup failed')}
                theme="filled_blue"
                size="large"
                text="signup_with"
                shape="pill"
              />
            </div>

            <div className="auth-footer">
              <span>Already have an account? <Link to="/" className="auth-link">Login</Link></span>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Signup;